/**
 * constants.js - Application-wide constants
 * 
 * @description
 * This file contains constants used throughout the application.
 */

// API base URL - uses the environment variable in production or local URL in development
export const API_BASE_URL = import.meta.env.PROD 
  ? 'https://ultimatebackend.onrender.com'  // Production - hosted backend
  : 'http://127.0.0.1:5000';  // Development - local backend

// Supported image formats for upload
export const SUPPORTED_IMAGE_FORMATS = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];

// Maximum image file size (10MB)
export const MAX_IMAGE_SIZE = 10 * 1024 * 1024; // 10MB in bytes
